import { StackProps } from "@mui/material";
import Button from "@mui/material/Button";
import CardActions from "@mui/material/CardActions";
import { useFormik } from "formik";
import _ from "lodash";
import {
	PolygonSimpleConfigs,
	SymbolStyle,
} from "~ui-components/types/__generated/gql/graphql";
import { PolygonStyle } from "../polygon-style";

type Props = StackProps & {
	form: ReturnType<typeof useFormik<PolygonSimpleConfigs>>;
};

const defaultSymbolStyle: SymbolStyle = {
	basic: null,
	fill: null,
	isGraphic: null,
	name: null,
	stroke: null,
};

export const PolygonSimpleStyle = (props: Props) => {
	const { form } = props;
	const {
		values: { symbolStyle },
		handleSubmit,
	} = form;

	return (
		<form onSubmit={handleSubmit}>
			<PolygonStyle
				value={{ symbolStyle: symbolStyle ?? defaultSymbolStyle }}
				onChange={(next) => form.setFieldValue("symbolStyle", next.symbolStyle)}
			/>
			<CardActions sx={{ justifyContent: "flex-end", p: 0, mt: 2 }}>
				<Button
					color="secondary"
					type="reset">
					Cancel
				</Button>
				<Button
					variant="contained"
					type="submit">
					Save changes
				</Button>
			</CardActions>
		</form>
	);
};
